import React, { useEffect, useState } from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useRecoilState } from 'recoil'
import { toastAtom, Toast as ToastType } from 'state'

const Toast = () => {
  const [globalToast, setGlobalToast] = useRecoilState(toastAtom)

  // Recoil state is copied locally so that removing the recoil toast doesn't cause the
  // Snackbar element's content to be removed while it animates out.
  const [localToast, setLocalToast] = useState<ToastType | null>()

  useEffect(() => {
    if (globalToast) {
      setLocalToast(globalToast)
    }
  }, [globalToast, setLocalToast])

  return (
    <Snackbar
      open={!!globalToast}
      autoHideDuration={6000}
      onClose={() => {
        setGlobalToast(null)
      }}
      sx={{
        zIndex: 9999, // toast must be above everything
      }}>
      <Alert severity={localToast?.severity}>{localToast?.title}</Alert>
    </Snackbar>
  )
}

export default Toast
